import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

// Reusable "Demander un devis" CTA. `service` preselects the prestation in the form.
export function QuoteButton({
  children = "Demander un devis",
  service,
  eventType,
  variant = "primary",
  className,
  testId = "quote-cta",
  onClickExtra,
}) {
  const qs = new URLSearchParams();
  if (service) qs.set("service", service);
  if (eventType) qs.set("type", eventType);
  const to = service === "Cheffe à domicile" ? "/devis/cheffe-a-domicile" : qs.toString() ? `/devis?${qs.toString()}` : "/devis";
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-7 py-3 text-sm font-medium tracking-wide transition-[background-color,color,transform,box-shadow] duration-300 hover:-translate-y-0.5";
  const variants = {
    primary: "bg-[#2C2C2C] text-white hover:bg-[#C9A84C] hover:text-[#2C2C2C] shadow-sm",
    gold: "bg-[#C9A84C] text-[#2C2C2C] hover:bg-[#2C2C2C] hover:text-white",
    outline:
      "border border-[#2C2C2C] text-[#2C2C2C] hover:bg-[#2C2C2C] hover:text-white",
    light: "border border-white/70 text-white hover:bg-white hover:text-[#2C2C2C]",
  };
  return (
    <Link
      to={to}
      data-testid={testId}
      onClick={() => {
        if (onClickExtra) onClickExtra();
        try {
          window.dispatchEvent(new CustomEvent("ar_track", { detail: { event: "quote_cta_click", service } }));
        } catch (e) {}
      }}
      className={cn(base, variants[variant], className)}
    >
      {children}
    </Link>
  );
}
